/**
 * SHA compiled into the API client. The administration footer reads /version.json.
 * Missing define (tests, a config that did not stamp) is "unknown", not a live clock.
 */
declare const __ZEPHIX_BUILD_SHA__: string;
function defined(value: unknown): string | null {
  return typeof value === 'string' && value.length > 0 ? value : null;
}

export const ZEPHIX_BUILD_SHA: string =
  defined(typeof __ZEPHIX_BUILD_SHA__ === 'string' ? __ZEPHIX_BUILD_SHA__ : undefined) ??
  'unknown';

